import { defineStore } from "pinia";
import { formFormatter } from "~/utils/helpers/ciFormatter";
import type { IFormState, IForm } from "~/types/contact/Types";

export const useContactFormStore = defineStore("ContactFormStore", {
  state: (): IFormState => ({
    isFetchingForm: true,
    formsList: [],
    targetForm: null,
    peopleForm: null,
    companiesForm: null,
  }),

  getters: {
    getFormsByType: (state) => (type: string) => {
      return state.formsList.find((form) => form.type === type) || null;
    },
  },

  actions: {
    async getForms() {
      try {
        const { data, error } = await useFetch<IForm[]>(`/api/contact/form/list`);
        this.formsList = data.value?.map((item: IForm) => {
          return {
            ...formFormatter(item),
          };
        });
      } catch (err: any) {
        console.log(err);
      }
    },

    async initializeForms() {
      this.isFetchingForm = true;
      await this.getForms();
      this.peopleForm = await this.getFormsByType("people")
      this.companiesForm = await this.getFormsByType("companies")
      this.isFetchingForm = false
    },

    setTargetForm(type: string) {
      this.targetForm = (type === "people" ? this.peopleForm : this.companiesForm) || { type };
    },

    watchFetchingForm(continueAfterFormsFetched: () => void) {
      if (!this.isFetchingForm) {
        // Forms are already fetched, proceed immediately
        continueAfterFormsFetched();
      } else {
        // Forms are still being fetched, use watch to wait
        const stopWatching = watch(
          () => this.isFetchingForm,
          (newValue) => {
            if (!newValue) {
              // Once fetching is done, proceed
              continueAfterFormsFetched();
              // Stop watching after the forms are fetched
              stopWatching();
            }
          }
        );
      }
    },
  }
});
